import React from "react";
import { Breadcrumbs as MUIBreadcrumbs, Typography } from "@material-ui/core";
// import { withRouter } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./BreadCrumb.scss";
import { useTranslation } from "react-i18next";
function containsOnlyNumbers(str: string) {
  return /^\d+$/.test(str);
}
const Breadcrumbs = (props: any) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  //   const {
  //     history,
  //     location: { pathname }
  //   } = props;
  let pathnames = window.location.pathname.split("/").filter((x) => x);

  return (
    <MUIBreadcrumbs aria-label="breadcrumb" className="pw-bread-crumbs">
      {pathnames.length > 0 ? (
        ""
      ) : (
        //<div  className="pw-bread-crumb-text text-neutral-500" onClick={() => navigate("/")}>Home</div>
        <Typography>{t("Home")} </Typography>
      )}
      {
        (pathnames = containsOnlyNumbers(pathnames[pathnames.length - 1])
          ? pathnames.slice(0, pathnames.length - 1)
          : pathnames)
      }
      {pathnames.map((name: any, index: number) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <div key={name} className="pw-bread-crumb-active">
            {/* {(name.charAt(0).toUpperCase() + name.slice(1))
                .replace(/([A-Z])/g, " $1")
                .trim()} */}
            {name.split("-").map((eachWord: any, index: number) => {
              let modifiedWord =
                eachWord.charAt(0).toUpperCase() + eachWord.slice(1);

              if (eachWord === "facilityconfigurations") {
                modifiedWord = "Facility Configuration";
              } else if (eachWord === "logemissions") {
                modifiedWord = "New Emission";
              } else if (eachWord === "customemissionfactor") {
                modifiedWord = "Custom Emission Factor";
              } else if (eachWord === "customemission") {
                modifiedWord = "Custom Emission";
              } else if (eachWord === "standardemissionfactor") {
                modifiedWord = "Standard Emission Factor";
              } else if (eachWord === "organisationInformation") {
                modifiedWord = "Organisation Information";
              } else if (eachWord === "organisationpreference") {
                modifiedWord = "Organisation Preferences";
              } else if (eachWord === "resourcecentre") {
                modifiedWord = "Resource Centre";
              }
              return (
                <span className="mr-1" key={index}>
                  {t(modifiedWord)}
                </span>
              );
            })}
          </div>
        ) : (
          <div
            key={name}
            className="pw-bread-crumb-text  text-neutral-500"
            // onClick={() => navigate(t(routeTo))}
          >
            {name.split("-").map((eachWord: any, index: number) => {
              console.log("each :", eachWord);
              if (eachWord === "datasource") {
                eachWord = "Data Sources";
              }
              return (
                <span className="m-1" key={index}>
                  {eachWord.charAt(0).toUpperCase() + eachWord.slice(1)}
                </span>
              );
            })}
          </div>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
